module.exports = __webpack_public_path__ + "img/DE00225.5230a984.png";